<template>
	<div class="c-page-header__video-contents">
		<iframe
			ref="iframe"
			:src="source"
			frameborder="0"
			webkitallowfullscreen
			mozallowfullscreen
			allowfullscreen
			v-if="videoEnabled"
			v-show="videoPlaybackStarted"
		></iframe>

		<div class="c-image-carousel__video-controls" v-if="videoEnabled">
			<button class="c-image-carousel__button c-image-carousel__button--alt" @click.prevent="toggleVideoState()" type="button">
				<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!videoPaused">
					<path d="M0 13.4615H4V0.538452H0V13.4615ZM8 0.538452V13.4615H12V0.538452H8Z" fill="currentColor"/>
				</svg>

				<svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="videoPaused">
					<path d="M0 0V14L11 7L0 0Z" fill="currentColor"/>
				</svg>

				<span v-if="!videoPaused">Pause video</span>
				<span v-if="videoPaused">Play video</span>
			</button>

			<button class="c-image-carousel__button" @click.prevent="toggleVideoDescription()" type="button" :aria-expanded="videoDescriptionVisible ? 'true' : 'false'" v-if="videoDescription">
				<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!videoDescriptionVisible">
					<path d="M16 5.11996L0 5.11107V6.88885H16V5.11996ZM0 9.55552H10.6667V11.3333H0V9.55552ZM16 0.666626H0V2.45329L16 2.4444V0.666626Z" fill="currentColor"/>
				</svg>

				<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="videoDescriptionVisible">
					<path d="M11 1.60786L9.89214 0.5L5.5 4.89214L1.10786 0.5L0 1.60786L4.39214 6L0 10.3921L1.10786 11.5L5.5 7.10786L9.89214 11.5L11 10.3921L6.60786 6L11 1.60786Z" fill="currentColor"/>
				</svg>

				<span v-if="!videoDescriptionVisible">Open description</span>
				<span v-if="videoDescriptionVisible">Close description</span>
			</button>

			<div class="h-one-whole" v-if="videoDescription">
				<div
					id="icvd"
					ref="videoDescription"
					class="c-image-carousel__video-description o-text"
					v-show="videoDescriptionVisible"
					v-html="videoDescription">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CookieConsent from "../mixins/cookie-consent.vue";
	import Player from "@vimeo/player";

	export default {
		mixins: [CookieConsent],
		data() {
			return {
				videoEnabled: false,
				videoPlaybackStarted: false,
				videoPaused: true,
				videoDescriptionVisible: false,
				requiredCookieCategories: ['analytics', 'marketing'],
			};
		},
		props: {
			source: {
				type: String
			},
			videoDescription: {
				type: String,
			},
		},
		watch: {
			hasCookieConsent: function () {
				this.updateEnabled();
			},
			videoEnabled() {
				if (!this.videoEnabled) {
					return;
				}

				this.$nextTick(this.bindPlayer);
			}
		},
		mounted() {
			document.addEventListener('keydown', (event) => {
				if (event.key === 'Escape') {
					this.videoDescriptionVisible = false;
				}
			});
		},
		methods: {
			updateEnabled() {
				var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
					return p.toString() === "[object SafariRemoteNotification]";
				})(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
				var self = this;

				if (self.$store.state.backgroundVideo && !isSafari && self.hasCookieConsent) {
					self.videoEnabled = true;
				} else {
					self.videoEnabled = false;
				}
			},
			bindPlayer() {
				console.log(this.$refs.iframe);

				if (this.player || !this.$refs.iframe) {
					return;
				}

				this.player = new Player(this.$refs.iframe);

				this.player.on('play', () => {
					this.videoPaused = false;
					this.videoPlaybackStarted = true;
				});

				this.player.on('pause', () => this.videoPaused = true);

				if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
					this.toggleVideoState(true);
				}
			},
			toggleVideoDescription() {
				this.videoDescriptionVisible = !this.videoDescriptionVisible;
			},
			toggleVideoState(toggle) {
				if (!this.player) {
					return;
				}

				this.player.getPaused().then((paused) => {
					if (typeof toggle === 'undefined') {
						toggle = paused;
					}

					toggle ? this.player.play() : this.player.pause();
				});
			},
		}
	}
</script>



// WEBPACK FOOTER //
// background-video.vue?3ac67d45